import SectionHeader from "../eventsExperiences/SectionHeader";

const REASONS = [
  { title: "Faster turnaround", desc: "No locations, crews or travel to coordinate. Revisions are quick, so your campaign reaches the market sooner." },
  { title: "Lower production cost", desc: "Sets, locations and effects are created digitally, so more of your budget goes into the idea and the media spend." },
  { title: "More versions to test", desc: "One concept becomes several hooks, lengths and formats, so you learn what works before you scale the spend." },
  { title: "Human-directed quality", desc: "Writers, directors and editors review every output. Nothing reaches you without a creative check." },
];

// White cards wait at the bottom of the section and flow up once the cards'
// own area reaches the middle of the screen (AOS "ai-rise", anchored to it),
// so the rise always plays in view.
const AiWhy = () => (
  <section className="ee-section ai-why">
    <div className="container">
      <SectionHeader eyebrow="Why AI-led" title="Why brands choose" accent="AI-led production." />
      <div className="ai-why-stage" id="ai-why-stage">
        {REASONS.map(({ title, desc }, i) => (
          <article
            className="ai-card"
            key={title}
            data-aos="ai-rise"
            data-aos-anchor="#ai-why-stage"
            data-aos-anchor-placement="center-center"
            data-aos-offset="0"
            data-aos-duration="1400"
            data-aos-delay={i === 0 || i === 3 ? 150 : 0}
            data-aos-once="true"
          >
            <h3>{title}</h3>
            <p>{desc}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default AiWhy;
